import { render } from "./ExcelReader.vue?vue&type=template&id=753aa1ce&scoped=true"
import script from "./ExcelReader.vue?vue&type=script&lang=js"
export * from "./ExcelReader.vue?vue&type=script&lang=js"

import "./ExcelReader.vue?vue&type=style&index=0&id=753aa1ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753aa1ce"]])

export default __exports__